import { formatDateToInputDateTime } from '@/business/utils/dates';
import CrudModule from '@/store/crudModule';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseModulePlugins from '@/store/baseModule/plugins';

export default (store) => {
  store.registerModule(
    ['requests', 'refresh'],
    new CrudModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/requests/refresh_list`,
        }),
        treatCurrentResponse: (response) => response.data,
      }),
      makeCreateParams: ({ rootGetters }) => {
        return {
          nav_full_id: rootGetters['entities/current'].map(
            (item) => item.nav_full_id
          ),
          datetime: formatDateToInputDateTime(
            rootGetters['requests/lastRefreshItemsDate']
          ),
        };
      },
    })
  );

  const TIMEOUT = 1000 * 120;

  const basePlugin = new BaseModulePlugins({
    module: 'requests/refresh',
    store,
  });

  store.subscribe((action) => {
    if (
      action.type === `${AUTHORIZATION_MODULE_PATH}/SET_AUTHORIZATION` &&
      action.payload.key === 'isDispatcher' &&
      action.payload.value
    ) {
      setTimeout(() => {
        store.dispatch('requests/refresh/createItem', {});
      }, TIMEOUT);
      basePlugin.onItemAddedOrModified(() => {
        setTimeout(() => {
          store.dispatch('requests/refresh/createItem', {});
        }, TIMEOUT);
      });
    }
  });
};
